import { UserResource } from "@clerk/types";
import { Database, MapPin, Network, Settings, Users } from "lucide-react";
import { isSuperAdmin } from "../utils/users";

export const PAGES = {
  DASHBOARD: "/dashboard",
  LOCATIONS: "/locations",
  USERS: "/users",
  DEVICES: "/devices",
  LOGIN: "/login",
  ADMIN: "/admin",
};

export const NAV_ITEMS = [
  {
    href: PAGES.DASHBOARD,
    link: "Dashboard",
    image: <Database className="mr-4" />,
    accessible: () => true,
  },
  {
    href: PAGES.DEVICES,
    link: "Devices",
    image: <Network className="mr-4" />,
    accessible: () => true,
  },
  {
    href: PAGES.LOCATIONS,
    link: "Locations",
    image: <MapPin className="mr-4" />,
    accessible: () => true,
  },
  {
    href: PAGES.USERS,
    link: "Users",
    image: <Users className="mr-4" />,
    accessible: () => true,
  },

  {
    href: PAGES.ADMIN,
    link: "Admin",
    image: <Settings className="mr-4" />,
    accessible: (user: UserResource | null | undefined) => isSuperAdmin(user),
  },
];
